export const logHandOffFailure = (handOff: Promise<void>): void => {
  void handOff.catch((e: unknown) => {
    console.error(e);
  });
};
